export const SERVICE_NAMES = {
  API: 'hsl-ems-api',
  WEB: 'hsl-ems-web',
  WORKER: 'hsl-ems-worker',
} as const;

export type ServiceName = (typeof SERVICE_NAMES)[keyof typeof SERVICE_NAMES];
